import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";


const HoppersRestaurantServicePage = ({ components }) => {
    const history = useHistory()
    const getDataIetm = (component) => {
        return (
            component?.Data?.map((serv, key) => {
                return (
                    <div className="HoppersRestaurantServicePage-item"
                        key={key}
                        style={{
                            backgroundImage: `linear-gradient(#00000080, #00000080), url(${serv?.background})
                        ` }}
                        onClick={() => {
                            history.push(serv?.href)
                        }}>
                        <div className="HoppersRestaurantServicePage-item-inner">
                            <div className="HoppersRestaurantServicePage-item-inner-wrapper">
                                <img className="HoppersRestaurantServicePage-item-inner-wrapper-ic"
                                    alt=""
                                    src={serv?.icon} />
                                <div
                                    className="HoppersRestaurantServicePage-item-inner-wrapper-text">
                                    {serv?.header}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantServicePage-item":
                return getDataIetm(component)

            default:
                return <div />
        }

    }
    return (
        <div className="HoppersRestaurantServicePage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div >
    )
}
export default HoppersRestaurantServicePage